<template>
   <v-container fluid class="px-10" style="height: 100vh">
      <v-row no-gutters class="d-flex">
         <v-col cols="12">
            <v-card>
               <v-toolbar dense :color="this.$globalstore.secondary_titleclass">
                  <v-toolbar-title v-if="$vuetify.breakpoint.mdAndUp">
                     View Group: {{ edit_cca_name }} [{{ edit_cca_termyeartext }}]
                  </v-toolbar-title>
                  <v-toolbar-title v-else>
                     {{ edit_cca_name }}
                  </v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-btn color="indigo" class="white" outlined @click="goBack()">
                     Back
                  </v-btn>
               </v-toolbar>
               <v-sheet outlined>
                  <v-tabs
                     height="40"
                     v-model="editgrouptab"
                     :slider-color="$globalstore.tab_slidercolor"
                     :show-arrows="!$vuetify.breakpoint.mdAndUp"
                  >
                     <v-tab href="#group">Group</v-tab>
                     <v-tab href="#event">Events</v-tab>
                     <v-tab href="#participants">Participants</v-tab>
                     <v-tab href="#waitlist">Wait List</v-tab>
                     <v-tab href="#email">Email</v-tab>
                  </v-tabs>
                  <v-tabs-items v-model="editgrouptab">
                     <v-tab-item :key="1" value="group">
                        <v-row no-gutters class="pa-0 mt-2 d-flex">
                           <v-col cols="10" md="4">
                              <v-text-field
                                 label="Group Name"
                                 class="ml-3 mt-1 mb-0"
                                 v-model="edit_cca_name"
                                 readonly
                              >
                              </v-text-field>
                              <v-text-field
                                 label="Group Description"
                                 class="ml-3 mt-1 mb-0"
                                 v-model="edit_cca_description"
                                 readonly
                              >
                              </v-text-field>
                           </v-col>
                           <v-col cols="8" md="2" class="px-2">
                              <v-select
                                 v-model="edit_cca_status"
                                 class="ml-5 my-0"
                                 label="Status"
                                 :items="$globalstore.status_select"
                                 item-text="text"
                                 item-value="id"
                                 return-object
                                 :rules="[(v) => !!v || 'Status is required']"
                                 required
                                 readonly
                              ></v-select>
                              <v-select
                                 class="ml-5 my-0"
                                 label="Gender"
                                 :items="$globalstore.gender_select"
                                 item-text="text"
                                 item-value="id"
                                 return-object
                                 v-model="edit_gender_constraint"
                                 readonly
                              ></v-select>
                           </v-col>
                           <v-col cols="6" md="2" class="px-2">
                              <datepicker-dialog
                                 class="mt-0 pt-0"
                                 :indate.sync="edit_publish_date"
                                 labelname="Publish Date"
                                 @return-date="onPublishDateChange"
                                 :datereadonly="datereadonly"
                              >
                              </datepicker-dialog>
                              <label class="caption mr-1" for="publishtime">Publish Time </label>
                              <vue-timepicker
                                 close-on-complete
                                 name="publishtime"
                                 :minute-interval="$globalstore.minute_interval"
                                 v-model="edit_publishtime"
                                 drop-direction="down"
                                 manual-input
                                 auto-scroll
                                 disabled
                              ></vue-timepicker>
                           </v-col>
                           <v-col cols="6" md="2" class="px-2">
                              <datepicker-dialog
                                 class="mt-0"
                                 labelname="Closing Date"
                                 :indate.sync="edit_closing_date"
                                 :datereadonly="datereadonly"
                              >
                              </datepicker-dialog>
                              <label class="caption mr-1" for="closingtime">Closing Time</label>
                              <vue-timepicker
                                 close-on-complete
                                 name="closingtime"
                                 :minute-interval="$globalstore.minute_interval"
                                 v-model="edit_closingtime"
                                 drop-direction="down"
                                 manual-input
                                 auto-scroll
                                 disabled
                              ></vue-timepicker>
                           </v-col>
                           <v-col cols="12" md="2">
                              <v-checkbox
                                 label="Consent Required"
                                 class="ml-4"
                                 v-model="edit_consent_required"
                                 readonly
                              ></v-checkbox>
                              <v-select
                                 class="ml-5 my-0"
                                 label="Limit Participant"
                                 :items="limitselect"
                                 item-text="text"
                                 item-value="id"
                                 return-object
                                 v-model="edit_limit_participant"
                                 readonly
                              ></v-select>
                           </v-col>
                        </v-row>

                        <v-row no-gutters class="pa-0 d-flex">
                           <v-col cols="12" md="6">
                              <year-select
                                 :yearreadonly="yearreadonly"
                                 :years.sync="edit_year_constraint"
                              >
                              </year-select>
                           </v-col>
                           <v-col cols="4" md="2" class="pl-2">
                              <v-card flat outlined>
                                 <v-card-text>
                                    <v-text-field
                                       class="pt-2"
                                       label="Minimum Participant"
                                       v-model="edit_min_participant"
                                       readonly
                                    ></v-text-field>
                                 </v-card-text>
                              </v-card>
                           </v-col>
                           <v-col cols="4" md="2" class="pl-2">
                              <v-card flat outlined>
                                 <v-card-text>
                                    <v-text-field
                                       class="pt-2"
                                       label="Maximum Participant"
                                       v-model="edit_max_participant"
                                       readonly
                                    ></v-text-field>
                                 </v-card-text>
                              </v-card>
                           </v-col>
                           <v-col cols="4" md="2" class="pl-2">
                              <v-card flat outlined>
                                 <v-card-text>
                                    <v-text-field
                                       class="pt-2"
                                       label="CCA Fee"
                                       v-model="edit_cca_fee"
                                       readonly
                                    ></v-text-field>
                                 </v-card-text>
                              </v-card>
                           </v-col>
                        </v-row>
                        <v-card outlined>
                           <v-row no-gutters>
                              <v-col cols="4" md="4">
                                 <v-select
                                    class="ml-2"
                                    label="CCA Schedule"
                                    :items="edit_scheduledata"
                                    item-text="schedule_name"
                                    item-value="id"
                                    return-object
                                    v-model="edit_schedule"
                                    readonly
                                 >
                                 </v-select>
                              </v-col>
                              <v-col cols="4" md="4" class="px-2">
                                 <v-text-field
                                    disabled
                                    v-if="edit_schedule"
                                    label="Start Date"
                                    readonly
                                    v-model="edit_schedule.schedule_startdate"
                                 ></v-text-field>
                              </v-col>
                              <v-col cols="4" md="4" class="px-2">
                                 <v-text-field
                                    disabled
                                    v-if="edit_schedule"
                                    label="End Date"
                                    readonly
                                    v-model="edit_schedule.schedule_enddate"
                                 ></v-text-field>
                              </v-col>
                           </v-row>
                        </v-card>
                        <v-row no-gutters class="d-flex pa-0">
                           <!-- left bottom -->
                           <v-col cols="12" md="7">
                              <v-row no-gutters class="pa-0 ma-0">
                                 <v-col md="2">
                                    <div class="ml-3 mt-3 text-start">
                                       <b>Event Master</b>
                                    </div>
                                 </v-col>
                                 <!-- <v-col md="10">
                                    <div class="my-0">
                                       <v-btn
                                          disabled
                                          x-small
                                          class="primary mx-1 my-2"
                                       >
                                          <v-icon small>mdi-plus</v-icon>
                                          Add
                                       </v-btn>
                                    </div>
                                 </v-col> -->
                              </v-row>

                              <!-- Event Master table -->
                              <v-row no-gutters>
                                 <v-col md="12">
                                    <v-card height="200px" class="overflow-y-auto">
                                       <v-data-table
                                          dense
                                          :headers="eventdata_headers"
                                          hide-default-footer
                                          :items="edit_eventdata"
                                          @click:row="eventdata_rowClick"
                                          item-key="id"
                                          single-select
                                       >
                                       </v-data-table>
                                    </v-card>
                                 </v-col>
                              </v-row>
                           </v-col>
                           <!-- Right bottom -->
                           <v-col cols="12" md="5">
                              <!-- admin button row -->
                              <v-row no-gutters class="pa-0 d-flex">
                                 <v-col md="4">
                                    <div class="ml-3 mt-3 text-start">
                                       <b>Administrators</b>
                                    </div>
                                 </v-col>
                                 <v-col md="8">
                                    <div class="my-0">
                                       <v-btn
                                          :disabled="
                                             !$globalstore.UserHasCap(CapConstant.ADD_GROUP_ADMIN)
                                          "
                                          x-small
                                          class="primary mx-1 my-2"
                                          @click.native="adminlistdlg = true"
                                          ><v-icon small>mdi-plus</v-icon>
                                          Add
                                       </v-btn>
                                    </div>
                                 </v-col>
                              </v-row>
                              <!-- admin table  -->
                              <v-row no-gutters class="full-height">
                                 <v-col>
                                    <v-card
                                       class="overflow-y-auto ml-1"
                                       height="200px"
                                       flat
                                       outlined
                                    >
                                       <v-data-table
                                          dense
                                          :headers="admindata_headers"
                                          hide-default-footer
                                          :items="edit_admindata"
                                          @click:row="admindata_rowClickAdmin"
                                          item-key="id"
                                          single-select
                                       >
                                          <!-- eslint-disable-next-line -->
                                          <template #item.actions="{ item }">
                                             <v-icon
                                                v-if="
                                                   $globalstore.UserHasCap(
                                                      CapConstant.ADD_GROUP_ADMIN
                                                   )
                                                "
                                                small
                                                @click="removeAdmin(item)"
                                                class="ml-2"
                                             >
                                                mdi-delete
                                             </v-icon>
                                          </template>
                                       </v-data-table>
                                    </v-card>
                                 </v-col>
                              </v-row>
                           </v-col>
                        </v-row>
                     </v-tab-item>
                     <!-- Events Listing Tab -->
                     <v-tab-item :key="2" value="event">
                        <edit-group-tab-event
                           :cca_id="edit_group_id"
                           :eventlist="eventlistdata"
                           :locationlist="locationdata"
                           @save-eventlist="saveEventListData"
                        ></edit-group-tab-event>
                     </v-tab-item>
                     <v-tab-item :key="3" value="participants">
                        <edit-group-tab-participant
                           :max_participant="edit_max_participant"
                           :cca_id="edit_group_id"
                           :consent="edit_consent_required"
                           :gender="edit_gender_constraint"
                           :year="edit_year_constraint"
                           :participants="participantdata"
                           :ccafee="edit_cca_fee"
                           :closingdate="edit_closing_date"
                           @save-participantlist="saveParticipantData"
                        >
                        </edit-group-tab-participant>
                     </v-tab-item>
                     <v-tab-item :key="4" value="waitlist">
                        <edit-group-tab-wait-list
                           :cca_id="edit_group_id"
                           :consent="edit_consent_required"
                           :gender="edit_gender_constraint"
                           :year="edit_year_constraint"
                           :ptcpdata="participantdata"
                           :waitlist_data="waitlistdata"
                           @save-waitlist="saveWaitListData"
                           @update-participant="reloadParticipantList"
                        ></edit-group-tab-wait-list>
                     </v-tab-item>
                     <v-tab-item :key="5" value="email">
                        <v-row>
                           <v-col cols="12" md="12">
                              <v-card outlined tile>
                                 <edit-group-tab-email
                                    :cca_id="edit_group_id"
                                    :participants="participantdata"
                                 ></edit-group-tab-email>
                              </v-card>
                           </v-col>
                        </v-row>
                     </v-tab-item>
                  </v-tabs-items>
               </v-sheet>
            </v-card>
         </v-col>
      </v-row>
      <group-admin-list
         :admindata="edit_admindata"
         :dialogvisible.sync="adminlistdlg"
         ref="adminlist"
         @cancel-selection="adminlistdlg = false"
         @save-selection="onAdminSaveSelection"
      />
   </v-container>
</template>

<script>
   import {GroupConst} from "@/common/constant.js";
   import DatepickerDialog from "@/components/DatepickerDialog";
   import GroupAdminList from "@/components/GroupAdminList.vue";
   import VueTimepicker from "vue2-timepicker/src/vue-timepicker.vue";
   import YearSelect from "@/components/YearSelect.vue";
   import EditGroupTabWaitList from "@/components/EditGroupTabWaitList.vue";
   import EditGroupTabEvent from "@/components/EditGroupTabEvent.vue";
   import EditGroupTabParticipant from "@/components/EditGroupTabParticipant.vue";
   import EditGroupTabEmail from "@/components/EditGroupTabEmail.vue";
   import CapConstant from "@/common/capconstant.js";

   export default {
      inject: ["ShowMessage"],

      components: {
         "datepicker-dialog": DatepickerDialog,
         "group-admin-list": GroupAdminList,
         VueTimepicker,
         YearSelect,
         EditGroupTabEvent,
         EditGroupTabParticipant,
         EditGroupTabWaitList,
         EditGroupTabEmail,
      },
      data() {
         return {
            datereadonly: true,
            yearreadonly: true,
            editgrouptab: "group",
            CapConstant: Object.freeze(CapConstant),
            limitselect: GroupConst.limitselect,
            edit_scheduledata: [],
            eventdata_headers: [
               {
                  text: "Day",
                  align: "start",
                  value: "daytext",
                  width: "25%",
                  class: this.$globalstore.table_headerclass,
               },
               {
                  text: "Start",
                  value: "start",
                  width: "15%",
                  class: this.$globalstore.table_headerclass,
               },
               {
                  text: "End",
                  value: "end",
                  width: "15%",
                  class: this.$globalstore.table_headerclass,
               },
               {
                  text: "Location",
                  value: "location_name",
                  width: "45%",
                  class: this.$globalstore.table_headerclass,
               },
            ],
            admindata_headers: [
               {
                  text: "Name",
                  align: "start",
                  value: "username",
                  class: this.$globalstore.table_headerclass,
               },
               {
                  text: "Role",
                  value: "userroles",
                  class: this.$globalstore.table_headerclass,
               },
               {
                  text: "",
                  value: "actions",
                  class: this.$globalstore.table_headerclass,
                  width: "5%",
                  sortable: false,
               },
            ],
            eventdayselect: GroupConst.eventdayselect,
            editgrouptabs: "",
            schedule_id: "",
            edit_schedule: null,
            edit_group_id: "",
            edit_cca_status: null,
            edit_cca_name: "",
            edit_cca_description: "",
            edit_cca_year: "",
            edit_cca_term: "",
            edit_cca_termyeartext: "",
            edit_gender_constraint: null,
            edit_year_constraint: [],
            edit_max_participant: 0,
            edit_min_participant: 0,
            edit_consent_required: false,
            eventdata_rowindex: -1,

            edit_eventdata: [],
            edit_admindata: [],
            edit_publish_date: "",
            edit_publishtime: "",
            edit_closing_date: "",
            edit_closingtime: "",
            edit_cca_fee: "0.00",
            edit_limit_participant: 0, //  0 = No Limitation 1 = Only students with  no CCA 2=By Invite

            locationdata: [],
            eventlistdata: [],

            participantdata: [],
            adminlistdlg: false,
            waitlistdata: [],
         };
      },

      // computed: {
      //    subscriber_exist() {
      //       return (
      //          this.participantdata.length > 0 || this.waitlistdata.length > 0
      //       );
      //    },
      // },

      methods: {
         goBack() {
            this.$router.go(-1);
         },

         onPublishDateChange(savedate) {
            this.edit_publish_date = savedate;
         },

         onClosingDateChange(savedate) {
            this.edit_closing_date = savedate;
         },

         async getGroupByID() {
            let response = await this.$http({
               url: "/cca/getgroup_byid.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  group_id: this.edit_group_id,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  let data = response.data.groupdata;
                  if (!data.error) {
                     // save id so it can be resolved after scheduledata
                     // has been loaded.
                     this.schedule_id = data.cca.schedule_id;

                     // this.edit_schedule = this.edit_scheduledata.find(
                     //    (x) => x.id == data.cca.schedule_id
                     // );
                     this.edit_cca_name = data.cca.cca_name;
                     this.edit_cca_description = data.cca.cca_description;
                     this.edit_cca_year = data.cca.cca_year;
                     this.edit_cca_term = data.cca.cca_term;
                     this.edit_cca_termyeartext = data.cca.termyeartext;
                     this.edit_cca_status = this.$globalstore.status_select.find(
                        (item) => item.id === data.cca.cca_status
                     );

                     this.edit_gender_constraint = this.$globalstore.gender_select.find(
                        (item) => item.id === data.cca.gender_constraint
                     );
                     // edit_year_constraint needs string
                     if (data.cca.year_constraint === 1) {
                        this.edit_year_constraint = data.years.map(String);
                     } else {
                        this.edit_year_constraint = [];
                     }
                     this.edit_publish_date = data.cca.publish_date;
                     this.edit_publishtime = data.cca.publish_time;
                     this.edit_closing_date = data.cca.closing_date;
                     this.edit_closingtime = data.cca.closing_time;
                     this.edit_min_participant = data.cca.min_participant;
                     this.edit_max_participant = data.cca.max_participant;
                     this.edit_consent_required = data.cca.consent_required;

                     this.edit_cca_fee = data.cca.cca_fee;
                     this.edit_limit_participant = this.limitselect.find(
                        (item) => item.id === data.cca.limit_participant
                     );
                     this.edit_admindata = data.admins;
                     this.edit_eventdata = data.eventmaster;
                     this.eventlistdata = data.events;
                     this.participantdata = data.participants;
                     this.waitlistdata = data.waitlist;
                  } else {
                     this.ShowMessage({
                        title: "Error",
                        message: data.message,
                        color: "red",
                     });
                  }
               }
            });
         },

         eventdata_rowClick(eventdata, row) {
            row.select(!row.isSelected);
         },

         admindata_rowClickAdmin(admindata, row) {
            row.select(!row.isSelected);
         },

         async onAdminSaveSelection(admin) {
            this.adminlistdlg = false;
            if (admin) {
               await this.$http({
                  url: "/cca/addadmin.php",
                  headers: {
                     "Content-Type": "application/x-www-form-urlencoded",
                  },
                  data: {
                     cca_id: this.edit_group_id,
                     admin_id: admin.id,
                     userid: this.$globalstore.user.userid,
                     token: this.$globalstore.user.usertoken,
                  },
                  method: "POST",
               }).then((response) => {
                  if (response.data.autherror) {
                     this.$globalstore.user.tokenexpired = true;
                  } else {
                     if (response.data.error) {
                        this.ShowMessage({
                           title: "Error",
                           message: response.data.message,
                           color: "red",
                        });
                     } else {
                        this.reloadAdminList();
                     }
                  }
               });
            }
         },

         async removeAdmin(item) {
            await this.$http({
               url: "/cca/removeadmin.php",
               headers: {
                  "Content-Type": "application/x-www-form-urlencoded",
               },
               data: {
                  cca_id: this.edit_group_id,
                  admin_id: item.id,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.reloadAdminList();
                  }
               }
            });
         },

         async LoadLocationList() {
            let response = await this.$http({
               url: "/cca/locationlist.php",
               method: "POST",
            });
            const data = response.data;
            if (!data.error) {
               this.locationdata = data.locationlist;
            } else {
               this.locationdata = [];
            }
         },

         saveWaitListData(data) {
            this.waitlistdata = data;
         },

         saveParticipantData(data) {
            this.participantdata = data;
         },

         saveEventListData(data) {
            this.eventlistdata = data;
         },

         async reloadParticipantList() {
            let response = await this.$http({
               url: "/cca/getparticipantlist.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {cca_id: this.edit_group_id},
               method: "POST",
            }).then((response) => {
               if (!response.data.error) {
                  this.participantdata = response.data.participantdata;
               }
            });
         },

         async LoadScheduleList() {
            let response = await this.$http({
               url: "/cca/getschedulelist.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  cca_year: this.edit_cca_year,
                  cca_term: this.edit_cca_term,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.edit_scheduledata = response.data.scheduledata;
                     if (this.schedule_id) {
                        this.edit_schedule = this.edit_scheduledata.find(
                           (x) => x.id == this.schedule_id
                        );
                     }
                  }
               }
            });
         },

         async reloadAdminList() {
            let response = await this.$http({
               url: "/cca/getadminlist.php",
               headers: {"Content-Type": "application/x-www-form-urlencoded"},
               data: {
                  cca_id: this.edit_group_id,
                  userid: this.$globalstore.user.userid,
                  token: this.$globalstore.user.usertoken,
               },
               method: "POST",
            }).then((response) => {
               if (response.data.autherror) {
                  this.$globalstore.user.tokenexpired = true;
               } else {
                  if (response.data.error) {
                     this.ShowMessage({
                        title: "Error",
                        message: response.data.message,
                        color: "red",
                     });
                  } else {
                     this.edit_admindata = response.data.admindata;
                  }
               }
            });
         },
      },

      async mounted() {
         if (this.$globalstore && this.$globalstore.appready) {
            if (this.$route.params.groupid) {
               await this.LoadLocationList();
               this.edit_group_id = this.$route.params.groupid;
               await this.getGroupByID();
               await this.LoadScheduleList();
            }
         }
      },
   };
</script>

<style>
   tr.v-data-table__selected {
      /* background: #7d92f5 !important; */
      background: #ffcdd2 !important;
   }
</style>
